export default __webpack_public_path__ + "static/media/711.a70444a6.png";